
/**
 * @fileOverview mmmLightBox Module File.
 *
 * This file is used to handle the showing/hiding of content. It is configurable to support the two main contexts in
 * which it is used.  The showing and hiding of the fly-out nav in mobile, and the showing and hiding of the content
 * drawers.
 *
 * @author jmaki
 * @version 1.0
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/LightBox',['require','lib/Util','jquery','controllers/ModalLaunchController','controllers/NavigationSubMenuController'],function (require) {
        var Util = require('lib/Util');
        var $ = require('jquery');
		var ModalLaunchCont = require('controllers/ModalLaunchController');
		var NavigationSubMenuCont = require('controllers/NavigationSubMenuController');

        /**
         * @name mmmLightBox
         * @class mmmLightBox binds the show/hide function to a  DOM element, identifies the target
         * @param element {Element} the domElement to bind to the event
         * @param app {object} the application instance
         * @constructor
         *
         * @since 1.0
         */
        var mmmLightBox = function (element) {
            this.$trigger = $(element); // wraps the trigger element in a jQuery object
            this.settings = undefined; // used to store the settings
            $debug('mmmLightBox loaded - use ?debug=mmmLightBox for messages');
            $debug('**** mmmLightBox Set Up Started **** ', 'mmmLightBox');
            this.init();
        };

        /**
         * Initializes the Controller
         *
         * @returns {mmmLightBox}
         * @since 1.0
         */
        mmmLightBox.prototype.init = function () {
            this.isEnabled = false;

            if (this.$trigger.length > 0) {
                return this.setOptions(),
						this.build();
            }
        };

        /**
         * Merges options from the DOM element with defaults
         * @return {mmmLightBox}
         */
        mmmLightBox.prototype.setOptions = function () {
            var options = this.$trigger.data().options;
            /* ToDo - Task: make some of the default class names more generic (isActive etc) */
            var defaults = {
                target: '#js-inlineModal',
				modalWidth: '90%',
				modalTop: '70px',
				modalID:'mmmLightBox'
            };
            this.settings = $.extend({}, defaults, options);  //merge defaults with data-options object
			$debug('\n\n******** mmmLightBox Options **********', 'mmmLightBox');
			$debug('     HTML data-options Settings: ' + $printObj(options),'mmmLightBox');
			$debug('     Default Settings: ' + $printObj(defaults),'mmmLightBox');
			$debug('     Combined Settings: ' + $printObj(this.settings),'mmmLightBox');
			return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @returns {SampleView}
         */
        mmmLightBox.prototype.createChildren = function () {
            // if the trigger has data-target, use that as the target, otherwise leave it undefined
            this.$target = $(this.settings.target);

            return this;
        };

        /**
         * Performs measurements and applys any positioning style logic
         *
         * @method build
         * @returns {FancyDropDown}
         * @public
         */
        mmmLightBox.prototype.build = function() {
            $debug('*** In build ***', 'mmmLightBox');
            var self = this;

			self.addModalID();
		};


		/**
        * Toggles the content, locks the transition, uses DOM to check current state
        * then calls close or open where appropriate
        *
        * @returns {mmmLightBox}
        * @since 1.0
        */
        mmmLightBox.prototype.addModalID = function () {
            var self = this,
				modalwidth = self.settings.modalWidth,
				modaltop = self.settings.modalTop,
                modaltargetID = self.settings.modalID,
				anchorID = 'a[href=#' + modaltargetID + ']';
			
			$debug('ADDED LIGHTBOX, ' + modaltargetID, 'mmmLightBox');
            
            // Add aria-label for close links
            $('.js-closeLink').attr('aria-label', 'close');

			$(anchorID).each(function(e){
                var el = $(this);
                var LightboxID = $('.MMM--modalContainer').attr('id');
					
				$debug('In EACH, ' + modaltargetID + e, 'mmmLightBox');
				if(modaltargetID === LightboxID){
					$debug('In Match, ANCHOR ' + modaltargetID + ' ID: ' + LightboxID, 'mmmLightBox');
					$('a[href=#' + modaltargetID + ']').wrap('<div class="js-modalTrigger" aria-haspopup="dialog" aria-modal="true" aria-labelledby="' + modaltargetID + '"></div>');

					$('.js-modalTrigger').attr('data-options', '{"target": \"#' +modaltargetID+ '\", "scrollToOnOpen": 310, "closeOn": "["contextChange", "contentClose"]"}');
				}
            });

            return this;
        };

        return mmmLightBox;
    });

}(MMMRequire));

